export class Coordinates{
    x:number
    y:number
    constructor(x:number = 0, y:number = 0){
        this.x = x
        this.y = y
    }
    toStringPoints = ():string => {
        return(String(this.x) + " " + String(this.y))
    }
    areEqual = (c:Coordinates) => {
        return(this.x === c.x && this.y === c.y)
    }
    clone = () => {
        return new Coordinates(this.x, this.y)
    }
    static FromArray = (a:number[]) => {
        return new Coordinates(a[0],a[1])
    }

} 